import { getDisplayCompanyId } from "utils/helpers";
import { models } from "powerbi-client";

export const formatName = (providers: any) => {
  providers.forEach((data: any) => {
    if (data.rmiRevFullName !== null) {
      const splitData = data.rmiRevFullName.split(",");
      data.rmiRevFullName = splitData.join(", ");
    }
    data.Provider =
      getDisplayCompanyId(data.rmiCompanyId) +
      " - (" +
      data.RmiClass +
      ") " +
      data.rmiRevFullName;
  });

  return providers;
};

export const getCombinedFilters = (provider: any, vendor: any) => {
  const filters: models.IBasicFilter[] = [];
  if (provider) {
    const providerDetail = JSON.parse(provider);
    filters.push({
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Providers",
        column: "PCP_KEYID",
      },
      operator: "In",
      values: [providerDetail.RmiProvKeyId],
      filterType: models.FilterType.Basic,
    });
  }

  if (vendor) {
    const vendorDetail = JSON.parse(vendor);
    filters.push({
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Providers",
        column: "TIN",
      },
      operator: "In",
      values: [vendorDetail.RmiVendorId],
      filterType: models.FilterType.Basic,
    });
  }

  return filters;
};
